export default [
  {
    label: 'User Requires State/Province Association',
    value: 'user.requires.states',
  },
  {
    label: 'User Requires Brand Association',
    value: 'user.requires.brands',
  },
  {
    label:
      'User Is Distributor Employee (Previously "User Requires Distributor Association")',
    value: 'user.requires.distributor',
  },
  {
    label: 'User Has Restricted Distributor Access (Henkel Employee)',
    value: 'user.requires.distributorRestriction',
  },
  {
    label: 'User Is Distributor Manager (Employed By Distributor)',
    value: 'user.is.distributormanager',
  },
  {
    label: 'User Requires Vendor No.',
    value: 'user.requires.vendornum',
  },
  {
    label:
      'User Requires Salon Association (Caution! Only one group can have this selected.)',
    value: 'user.requires.salon',
  },
  {
    label: 'User Assignable to Salon',
    value: 'user.assignable.salon',
  },
  {
    label: 'Sales Rep (Caution! Only one group can have this selected.)',
    value: 'user.is.salesRep',
  },
  {
    label: 'User Assign Sales Rep',
    value: 'user.assign.salesRep',
  },
  {
    label: 'Engage360 - Manager',
    value: 'user.manager.advisornet',
  },
  {
    label: 'Engage360 - Performs Education Activities',
    value: 'user.advisornet.education',
  },
  {
    label: 'Engage360 - Can Submit Expenses',
    value: 'user.advisornet.expenses',
  },
  {
    label: 'Engage360 - Expenses Requires Activity',
    value: 'user.advisornet.expenses.requires.activity',
  },
  {
    label: 'Engage360 - Expenses Requires Location',
    value: 'user.advisornet.expenses.requires.location',
  },
  {
    label: 'Engage360 - Expenses Requires Distributor',
    value: 'user.advisornet.expenses.requires.distributor',
  },
  // {
  //   label: 'Engage360 - Expenses Requires Type',
  //   value: 'user.advisornet.expenses.requires.type',
  // },
  {
    label: 'Engage360 - Expenses Requires Days Worked',
    value: 'user.advisornet.expenses.requires.daysworked',
  },
  {
    label: 'Engage360 - Expenses Requires Hours Worked',
    value: 'user.advisornet.expenses.requires.hoursworked',
  },
  {
    label: 'Engage360 - Expenses Requires Travel Day Rate',
    value: 'user.advisornet.expenses.requires.traveldayrate',
  },
  {
    label: 'Engage360 - Expenses Requires Social Takeover Rate',
    value: 'user.advisornet.expenses.requires.socialtakeoverrate',
  },
  {
    label: 'Engage360 - Expenses Requires Cost Center',
    value: 'user.advisornet.expenses.requires.costcenter',
  },
  {
    label: 'Engage360 - Expenses Requires Tax Number',
    value: 'user.advisornet.expenses.requires.taxnumber',
  },
  // {
  //   label: 'Messenger - Can Send Group/Bulk Messages',
  //   value: 'user.messenger.sendBulk',
  // },
  // {
  //   label:
  //     'Messenger - Can Send Direct Message (Dynamic user filters still apply)',
  //   value: 'user.messenger.sendDirect',
  // },
  // {
  //   label: 'Messenger - Can Send Direct Distributor User Messages',
  //   value: 'user.messenger.sendToDistributorUser',
  // },
  // {
  //   label: 'Messenger - Can Send Direct Education User Messages',
  //   value: 'user.messenger.sendToEducationUser',
  // },
  // {
  //   label: 'Messenger - Can Send Direct Salon Messages',
  //   value: 'user.messenger.sendToSalons',
  // },
  {
    label: 'Mytracker - Can Export Data',
    value: 'user.mytracker.canExport',
  },
  {
    label: 'Mytracker - Executive Reporting',
    value: 'user.mytracker.executiveReporting',
  },
  {
    label: 'Mytracker - ClubH Dashboard',
    value: 'user.mytracker.loyaltyDashboard',
  },
  {
    label: 'POE - Can Export Expenses',
    value: 'user.poe.canExportExpenses',
  },
  {
    label: 'SalonDB - Full Access',
    value: 'user.salondb.fullAccess',
  },
  {
    label: 'SalonDB - Can Export Data',
    value: 'user.salondb.canExport',
  },
  {
    label: 'SalonDB - Can Merge Accounts',
    value: 'user.salondb.canMerge',
  },
  {
    label: 'SalonDB - Can Create Salon Card',
    value: 'user.salondb.canCreateSalonCard',
  },
  {
    label: 'SalonDB - Hide Sales Information',
    value: 'user.salondb.hideSalesInfo',
  },
];



// WEBPACK FOOTER //
// ./src/configs/groups.js